document.addEventListener("DOMContentLoaded", () => {
  let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

  document.querySelectorAll(".wishlist-wrapper").forEach(wrapper => {
    const btn = wrapper.querySelector(".wishlist-btn");
    const msg = wrapper.querySelector(".wishlist-msg");
    const handle = btn.dataset.productHandle;

    // Initial state
    if (wishlist.includes(handle)) {
      btn.classList.add("active");
    }

    btn.addEventListener("click", () => {
      if (wishlist.includes(handle)) {
        wishlist = wishlist.filter(h => h !== handle);
        btn.classList.remove("active");
        msg.classList.remove("show");
      } else {
        wishlist.push(handle);
        btn.classList.add("active");
        msg.classList.add("show");

        // Auto hide message
        setTimeout(() => {
          msg.classList.remove("show");
        }, 1500);
      }

      localStorage.setItem("wishlist", JSON.stringify(wishlist));
    });
  });
});
